import { Component, EventEmitter,Input, Output , OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

interface Order {
  orderName: string;
  category_description: string;
  frequencyVal: string | number[] | string[]; // Can be JSON string or array
  id: number;
  name: string;
  orderCategory: string;
  orderType: number;
  prerequisiteOrder: string;
  response: string;
  routeUrgencyId: string;
  routeUrgencyVal: string | number[] | string[]; // Can be JSON string or array
  type: string;
  orderDay?: number;           // New property for calculated order day
  orderReturnTime?: string;    // New property for calculated return time
  [key: string]: any;
}

interface CategorizedOrder {
  value: string;
  orderslist: any[] ;
}

// New interface for prerequisite management
interface PrerequisiteStack {
  mainOrder: Order;
  prerequisiteChain: Order[];
}

@Component({
  selector: 'app-orders-popup',
  templateUrl: './orders-popup.component.html',
  styleUrls: ['./orders-popup.component.scss']
})
export class OrdersPopupComponent implements OnChanges , OnInit {
  @Output() close = new EventEmitter<void>();
  @Output() confirmOrders = new EventEmitter<{order: Order, isPrerequisite: boolean}>();
  @Input() orderList: Order[];
  @Input() currentCaseDay: number = 1;        // New input for current simulation day
  @Input() currentCaseTime: string = '00:00'; // New input for current simulation time
  @Input() selectedOrderIds: number[] = [];   // New input to track selected order IDs
  @Input() cancelledOrders: Order[] = [];     // New input to receive cancelled orders
  
  ordersText: string = '';
  isVerificationMode: boolean = false;
  categorizedOrdersData: CategorizedOrder[] = [];
  currentCategoryIndex: number = 0;

  // New properties to manage order state
  private removedOrderIds: Set<number> = new Set(); // Track orders removed from search
  private availableOrders: Order[] = []; // Filtered list of available orders
  
  // New properties for error handling
  private selectedOrdersForCategories: Map<number, Order> = new Map(); // Track selected order for each category
  showErrorPopup: boolean = false; // Show error popup state
  errorMessage: string = ''; // Error message to display

  // New properties for prerequisite management
  isPrerequisiteMode: boolean = false;
  prerequisiteStack: PrerequisiteStack | null = null;

  // New properties for consultation management
  showConsultationPopup: boolean = false;
  consultationReason: string = '';
  pendingConsultationOrder: Order | null = null;

   // frequency list 
   frequencyList = [
    {
        "id": 0,
        "type": "N/A"
    },
    {
        "id": 1,
        "type": "Continuous"
    },
    {
        "id": 2,
        "type": "Every X"
    },
    {
        "id": 3,
        "type": "One Time/Bolus"
    }
]
  // ungencry array
  urgCodes = [
    {
        "id": 0,
        "type": "N/A",
        "reportTime": "0"
    },
    {
        "id": 1,
        "type": "Routine",
        "reportTime": "8"
    },
    {
        "id": 2,
        "type": "Stat",
        "reportTime": "4"
    }
]

//routes array  
routeCodes = [
  {
      "id": 0,
      "type": "N/A",
      "abbr": "N/A"
  },
  {
      "id": 1,
      "type": "Epidural",
      "abbr": "ED"
  },
  {
      "id": 2,
      "type": "IntraArticular",
      "abbr": "IA"
  },
  {
      "id": 3,
      "type": "IntraMuscular",
      "abbr": "IM"
  },
  {
      "id": 4,
      "type": "Intravenous",
      "abbr": "IV"
  },
  {
      "id": 5,
      "type": "Inhalation",
      "abbr": "IN"
  },
  {
      "id": 6,
      "type": "opthalmic",
      "abbr": "OP"
  },
  {
      "id": 7,
      "type": "Oral",
      "abbr": "PO"
  },
  {
      "id": 8,
      "type": "Otic",
      "abbr": "OT"
  },
  {
      "id": 9,
      "type": "Rectal",
      "abbr": "RE"
  },
  {
      "id": 10,
      "type": "Subcutaneous",
      "abbr": "SC"
  },
  {
      "id": 11,
      "type": "Sublingual",
      "abbr": "SL"
  },
  {
      "id": 12,
      "type": "Topical",
      "abbr": "TP"
  },
  {
      "id": 13,
      "type": "Vaginal",
      "abbr": "VA"
  }
]
  

  // New properties for qualifier popup
  showQualifierPopup: boolean = false;
  selectedOrder: Order | null = null;
  selectedOrders: Order[] = [];
  qualifierData = {
    frequency: '',
    urgency: 'routine',  // default value
    selectedFrequencyOption: '',
    selectedRouteOption: '',
    selectedUrgencyOption: ''
  };

  get currentCategory(): CategorizedOrder | null {
    return this.isVerificationMode && this.categorizedOrdersData.length > this.currentCategoryIndex
      ? this.categorizedOrdersData[this.currentCategoryIndex]
      : null;
  }
constructor()
{
  console.log('&&&&&&&&&&&&&&&&&&&&&&&&')
}
  private getOrdersArray(): string[] {
    // Split by newline and filter out empty lines
    return this.ordersText
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0);
  }

  private categorizeOrders(substrings: string[]): CategorizedOrder[] {

    
    const result = substrings.map(substring => {
      const matchingOrders = this.availableOrders?.filter(order => 
        order.orderName?.toLowerCase().startsWith(substring.toLowerCase())
      ) || [];
      
   
      
      return {
        value: substring,
        orderslist: matchingOrders
      };
    });
    
    return result;
  }
  ngOnInit(): void {
    this.updateAvailableOrders();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle changes to selectedOrderIds or cancelledOrders
    if (changes['selectedOrderIds'] || changes['cancelledOrders'] || changes['orderList']) {
      this.updateAvailableOrders();
    }
    
    // Handle cancelled orders restoration
    if (changes['cancelledOrders'] && this.cancelledOrders && this.cancelledOrders.length > 0) {
      this.restoreCancelledOrders();
    }
  }

  // New method to update the list of available orders
  private updateAvailableOrders(): void {
    if (!this.orderList) {
      console.warn('No orderList provided');
      this.availableOrders = [];
      return;
    }

   

    // Simplify the filtering logic - only exclude orders that are selected AND not removed
    this.availableOrders = this.orderList.filter(order => 
      !this.selectedOrderIds.includes(order.id) || this.removedOrderIds.has(order.id)
    );
    
  }

  // New method to restore cancelled orders to available list
  private restoreCancelledOrders(): void {
    this.cancelledOrders.forEach(cancelledOrder => {
      // Remove from removedOrderIds so it appears in search again
      this.removedOrderIds.delete(cancelledOrder.id);
    });
    
    // Update available orders after restoration
    this.updateAvailableOrders();
  }

  onClose(): void {
    this.resetState();
    this.close.emit();
  }

  private resetState(): void {
    this.isVerificationMode = false;
    this.categorizedOrdersData = [];
    this.currentCategoryIndex = 0;
    this.ordersText = '';
    // Clear selected orders tracking
    this.selectedOrdersForCategories.clear();
    // Reset prerequisite state
    this.resetPrerequisiteState();
  }

  // New method to reset prerequisite state
  private resetPrerequisiteState(): void {
    this.isPrerequisiteMode = false;
    this.prerequisiteStack = null;
  }

  // New method to parse prerequisite orders from string
  private parsePrerequisites(order: Order): number[] {
    if (!order.prerequisiteOrder || order.prerequisiteOrder.trim() === '') {
      return [];
    }
    
    try {
      // First try to parse as JSON array (e.g., "[198351,729662,430830]")
      if (order.prerequisiteOrder.startsWith('[') && order.prerequisiteOrder.endsWith(']')) {
        const parsedArray = JSON.parse(order.prerequisiteOrder);
        if (Array.isArray(parsedArray)) {
          return parsedArray.map(id => parseInt(id)).filter(id => !isNaN(id));
        }
      }
      
      // Fallback: Handle comma-separated IDs (e.g., "198351,729662,430830")
      return order.prerequisiteOrder
        .split(',')
        .map(id => parseInt(id.trim()))
        .filter(id => !isNaN(id));
    } catch (e) {
      console.error('Error parsing prerequisite orders:', e);
      return [];
    }
  }

  // New method to find order by ID
  private findOrderById(orderId: number): Order | null {
    return this.orderList?.find(order => order.id === orderId) || null;
  }

  onConfirm(): void {
    if (!this.isVerificationMode) {
      // Initial confirmation - move to verification mode
      const ordersArray = this.getOrdersArray();
     
      this.categorizedOrdersData = this.categorizeOrders(ordersArray);
      
      if (this.categorizedOrdersData.length > 0) {
        this.isVerificationMode = true;
        this.currentCategoryIndex = 0;
      } else {
        console.warn('No orders found for the entered text');
        this.showErrorPopup = true;
        this.errorMessage = 'No orders found matching your search terms. Please try different keywords.';
      }
    } else {
      // In verification mode - only handle normal mode (prerequisite mode is handled in qualifier)
      if (this.isPrerequisiteMode) {
        // In prerequisite mode - this shouldn't be called as orders are handled in qualifier
        this.showErrorPopup = true;
        this.errorMessage = 'Please select an order to proceed';
        return;
      }
      
      // Normal mode - check if an order has been selected for current category
      if (!this.selectedOrdersForCategories.has(this.currentCategoryIndex)) {
        // No order selected for current category - show error popup
        this.showErrorPopup = true;
        this.errorMessage = 'Please select an Order';
        return;
      }
      
      // Order selected - move to next category or finish
      this.currentCategoryIndex++;
      
      if (this.currentCategoryIndex >= this.categorizedOrdersData.length) {
        // All categories completed - emit all selected orders
        const allSelectedOrders = Array.from(this.selectedOrdersForCategories.values());
        
        // Process each selected order
        allSelectedOrders.forEach(order => {
          // Calculate timing for this order based on current simulation time
          this.calculateOrderTiming(order);
          
          // Track this order as selected (remove from available search results)
          this.removedOrderIds.add(order.id);
          
          // Emit the order
          this.confirmOrders.emit({
            order: order,
            isPrerequisite: false
          });
        });
        
        // Update available orders after processing all selections
        this.updateAvailableOrders();
        
        // Reset state and close
        this.resetState();
        this.close.emit();
      } else {
        
      }
    }
  }

  onCancel(): void {
    if (this.isVerificationMode || this.isPrerequisiteMode) {
      this.resetState();
    }
    this.close.emit();
  }

  onBack(): void {
    if (this.currentCategoryIndex > 0) {
      // Clear selections for categories after the one we're going back to
      const keysToDelete = Array.from(this.selectedOrdersForCategories.keys())
        .filter(key => key >= this.currentCategoryIndex);
      keysToDelete.forEach(key => this.selectedOrdersForCategories.delete(key));
      
      this.currentCategoryIndex--;
    }
  }

  onOrderClick(order: Order): void {
    console.log('onOrderClick called', order);
    
    if (!this.isPrerequisiteMode) {
      const prerequisiteIds = this.parsePrerequisites(order);
      
      if (prerequisiteIds.length > 0) {
        // Order has prerequisites - initialize prerequisite mode
        this.prerequisiteStack = {
          mainOrder: order,
          prerequisiteChain: [order] // Start with main order in the stack
        };
        this.isPrerequisiteMode = true;
        
        // Show prerequisite orders as a list for user to select from
        const prerequisiteOrders = prerequisiteIds
          .map(id => this.findOrderById(id))
          .filter(prereqOrder => prereqOrder !== null) as Order[];
        
        // Update the current category to show prerequisites
        this.categorizedOrdersData[this.currentCategoryIndex] = {
          value: `Prerequisites for "${order.orderName}"`,
          orderslist: prerequisiteOrders
        };
        
        return;
      }
    }
    
    // Order selection (either normal order or prerequisite order)
    const prerequisiteIds = this.parsePrerequisites(order);
    
    if (prerequisiteIds.length > 0) {
      // This selected order has its own prerequisites
      // Add this order to the stack (it will be qualified later)
      if (this.isPrerequisiteMode && this.prerequisiteStack) {
        this.prerequisiteStack.prerequisiteChain.push(order);
        console.log('Added to stack:', order.orderName);
        console.log('Current stack:', this.prerequisiteStack.prerequisiteChain.map(o => o.orderName));
      }
      
      // Show sub-prerequisites
      const subPrerequisiteOrders = prerequisiteIds
        .map(id => this.findOrderById(id))
        .filter(prereqOrder => prereqOrder !== null) as Order[];
      
      this.categorizedOrdersData[this.currentCategoryIndex] = {
        value: `Prerequisites for "${order.orderName}"`,
        orderslist: subPrerequisiteOrders
      };
      
      return;
    }
    
    // No prerequisites - this is the deepest level
    if (this.isPrerequisiteMode && this.prerequisiteStack) {
      // Add the deepest order to the stack
      this.prerequisiteStack.prerequisiteChain.push(order);
      console.log('Added deepest order to stack:', order.orderName);
      console.log('Complete stack before reversal:', this.prerequisiteStack.prerequisiteChain.map(o => o.orderName));
      
      // Reverse the stack so we qualify from deepest to main order
      this.prerequisiteStack.prerequisiteChain.reverse();
      console.log('Reversed stack for qualification:', this.prerequisiteStack.prerequisiteChain.map(o => o.orderName));
      
      // Start qualification with the first order in the reversed stack (deepest prerequisite)
      this.selectedOrder = order; // This is the deepest order
      this.showQualifierPopup = true;
      this.resetQualifierData();
      return;
    }
    
    // Normal mode - just show qualifier popup
    this.selectedOrder = order;
    this.showQualifierPopup = true;
    this.resetQualifierData();
  }

  // Helper method to determine frequency display type
  getFrequencyDisplayType(): 'input' | 'radio' | 'none' {
    if (!this.selectedOrder?.frequencyVal || this.selectedOrder.frequencyVal === '') {
      return 'none';
    }
    
    try {
      let frequencyIds: (number | string)[];
      
      // Handle both string and array formats
      if (typeof this.selectedOrder.frequencyVal === 'string') {
        frequencyIds = JSON.parse(this.selectedOrder.frequencyVal);
      } else if (Array.isArray(this.selectedOrder.frequencyVal)) {
        frequencyIds = this.selectedOrder.frequencyVal;
      } else {
        return 'none';
      }
      
      if (Array.isArray(frequencyIds) && frequencyIds.length > 0) {
        // Use case 1: If there is only 1 element and it has id '2'
        if (frequencyIds.length === 1 && (frequencyIds[0] == 2)) {
          return 'input';
        }
        // Use case 2: If there are ids other than '2' or multiple ids
        return 'radio';
      }
    } catch (e) {
      console.error('Error parsing frequencyVal:', e);
    }
    return 'none';
  }

  // Get filtered frequency options for radio buttons
  getFrequencyOptions(): any[] {
    if (!this.selectedOrder?.frequencyVal || this.selectedOrder.frequencyVal === '') {
      return [];
    }
    
    try {
      let frequencyIds: (number | string)[];
      
      // Handle both string and array formats
      if (typeof this.selectedOrder.frequencyVal === 'string') {
        frequencyIds = JSON.parse(this.selectedOrder.frequencyVal);
      } else if (Array.isArray(this.selectedOrder.frequencyVal)) {
        frequencyIds = this.selectedOrder.frequencyVal;
      } else {
        return [];
      }
      
      if (Array.isArray(frequencyIds)) {
        return this.frequencyList.filter(freq => 
          frequencyIds.some(id => id == freq.id)
        );
      }
    } catch (e) {
      console.error('Error parsing frequencyVal:', e);
    }
    return [];
  }

  // Determine what to show for route/urgency based on routeUrgencyId
  getRouteUrgencyDisplayType(): 'route' | 'urgency' | 'none' {
    if (!this.selectedOrder?.routeUrgencyId || this.selectedOrder.routeUrgencyId === '') {
      return 'none';
    }
    
    if (this.selectedOrder.routeUrgencyId === '1') {
      return 'route';
    }
    if (this.selectedOrder.routeUrgencyId === '2') {
      return 'urgency';
    }
    return 'none';
  }

  // Get filtered route options
  getRouteOptions(): any[] {
    if (!this.selectedOrder?.routeUrgencyVal || this.selectedOrder.routeUrgencyVal === '') {
      return [];
    }
    
    try {
      let routeIds: (number | string)[];
      
      // Handle both string and array formats
      if (typeof this.selectedOrder.routeUrgencyVal === 'string') {
        routeIds = JSON.parse(this.selectedOrder.routeUrgencyVal);
      } else if (Array.isArray(this.selectedOrder.routeUrgencyVal)) {
        routeIds = this.selectedOrder.routeUrgencyVal;
      } else {
        return [];
      }
      
      if (Array.isArray(routeIds)) {
        return this.routeCodes.filter(route => 
          routeIds.some(id => id == route.id)
        );
      }
    } catch (e) {
      console.error('Error parsing routeUrgencyVal for routes:', e);
    }
    return [];
  }

  // Get filtered urgency options
  getUrgencyOptions(): any[] {
    if (!this.selectedOrder?.routeUrgencyVal || this.selectedOrder.routeUrgencyVal === '') {
      return [];
    }
    
    try {
      let urgencyIds: (number | string)[];
      
      // Handle both string and array formats
      if (typeof this.selectedOrder.routeUrgencyVal === 'string') {
        urgencyIds = JSON.parse(this.selectedOrder.routeUrgencyVal);
      } else if (Array.isArray(this.selectedOrder.routeUrgencyVal)) {
        urgencyIds = this.selectedOrder.routeUrgencyVal;
      } else {
        return [];
      }
      
      if (Array.isArray(urgencyIds)) {
        return this.urgCodes.filter(urgency => 
          urgencyIds.some(id => id == urgency.id)
        );
      }
    } catch (e) {
      console.error('Error parsing routeUrgencyVal for urgency:', e);
    }
    return [];
  }

  onQualifierConfirm(): void {
    this.selectedOrder['responseShown'] = false;
    if (this.selectedOrder) {
      // Basic validation
      const frequencyType = this.getFrequencyDisplayType();
      const routeUrgencyType = this.getRouteUrgencyDisplayType();
      
      // Create order with qualifiers
      const orderWithQualifiers = {
        ...this.selectedOrder,
        selectedFrequency: this.qualifierData.frequency,
        selectedUrgency: this.qualifierData.urgency,
        selectedFrequencyOption: this.qualifierData.selectedFrequencyOption,
        selectedRouteOption: this.qualifierData.selectedRouteOption,
        selectedUrgencyOption: this.qualifierData.selectedUrgencyOption
      };
      
      // Check if this is a consultation order (orderType === 1)
      if (this.selectedOrder.orderType === 1) {
        // For consultation orders, show the consultation popup
        this.pendingConsultationOrder = orderWithQualifiers;
        this.showConsultationPopup = true;
        this.closeQualifierPopup(); // Close the qualifier popup
        return; // Don't emit order yet - wait for consultation completion
      }
      
      // Handle order selection based on mode
      if (this.isPrerequisiteMode && this.prerequisiteStack) {
        // In prerequisite mode - emit this order immediately
        console.log('Qualifying and emitting order:', orderWithQualifiers.orderName);
        this.calculateOrderTiming(orderWithQualifiers);
        this.removedOrderIds.add(orderWithQualifiers.id);
        
        // Determine if this is the main order or a prerequisite
        const isMainOrder = this.prerequisiteStack.mainOrder.id === orderWithQualifiers.id;
        
        this.confirmOrders.emit({
          order: orderWithQualifiers,
          isPrerequisite: !isMainOrder
        });
        
        // Remove the processed order from the stack
        this.prerequisiteStack.prerequisiteChain.shift();
        console.log('Removed processed order, remaining stack:', this.prerequisiteStack.prerequisiteChain.map(o => o.orderName));
        
        // Close qualifier popup
        this.closeQualifierPopup();
        
        // Check if there are more orders in the stack to qualify
        if (this.prerequisiteStack.prerequisiteChain.length > 0) {
          const nextOrderToQualify = this.prerequisiteStack.prerequisiteChain[0]; // Get next order but don't remove it yet
          console.log('Next order to qualify:', nextOrderToQualify?.orderName);
          
          if (nextOrderToQualify) {
            // Show qualifier for the next order
            this.selectedOrder = nextOrderToQualify;
            this.showQualifierPopup = true;
            this.resetQualifierData();
            return;
          }
        }
        
        // No more orders in stack - finish prerequisite mode
        console.log('All orders qualified, finishing prerequisite mode');
        this.updateAvailableOrders();
        this.resetState();
        this.close.emit();
        
      } else {
        // Normal mode - emit the order immediately (for simple orders without prerequisites)
        console.log('Normal mode: Qualifying and emitting order:', orderWithQualifiers.orderName);
        this.calculateOrderTiming(orderWithQualifiers);
        this.removedOrderIds.add(orderWithQualifiers.id);
        
        this.confirmOrders.emit({
          order: orderWithQualifiers,
          isPrerequisite: false
        });
        
        // For normal mode, we can close the popup immediately since it's a simple order
        this.updateAvailableOrders();
        this.resetState();
        this.close.emit();
      }
    }
  }

  proceedWithOrder(): void {
    if (this.selectedOrder) {
      const orderWithQualifiers = {
        ...this.selectedOrder,
        selectedFrequency: this.qualifierData.frequency,
        selectedUrgency: this.qualifierData.urgency,
        selectedFrequencyOption: this.qualifierData.selectedFrequencyOption,
        selectedRouteOption: this.qualifierData.selectedRouteOption,
        selectedUrgencyOption: this.qualifierData.selectedUrgencyOption
      };
      
      
      console.log('isPrerequisiteMode', this.isPrerequisiteMode , this.prerequisiteStack)
      if (this.isPrerequisiteMode && this.prerequisiteStack) {
        // In prerequisite mode - emit this order immediately
        console.log('Qualifying and emitting order:', orderWithQualifiers.orderName);
        this.calculateOrderTiming(orderWithQualifiers);
        this.removedOrderIds.add(orderWithQualifiers.id);
        // this.confirmOrders.emit(orderWithQualifiers);
        
        // Close qualifier popup
        this.closeQualifierPopup();
        
        // Check if there are more orders in the stack to qualify
        if (this.prerequisiteStack.prerequisiteChain.length > 0) {
          const nextOrderToQualify = this.prerequisiteStack.prerequisiteChain.shift();
          console.log('Next order to qualify:', nextOrderToQualify?.orderName);
          console.log('Remaining stack:', this.prerequisiteStack.prerequisiteChain.map(o => o.orderName));
          
          if (nextOrderToQualify) {
            // Show qualifier for the next order
            this.selectedOrder = nextOrderToQualify;
            this.showQualifierPopup = true;
            this.resetQualifierData();
            return;
          }
        }
        
        // No more orders in stack - finish prerequisite mode
        console.log('All orders qualified, finishing prerequisite mode');
        this.updateAvailableOrders();
        this.resetState();
        this.close.emit();
        
      } else {
        // Normal mode - track the qualified order and close qualifier
        this.selectedOrdersForCategories.set(this.currentCategoryIndex, orderWithQualifiers);
        this.closeQualifierPopup();
      }
    }
  }

  // Helper method to reset qualifier data
  private resetQualifierData(): void {
    this.qualifierData = {
      frequency: '',
      urgency: 'routine',
      selectedFrequencyOption: '',
      selectedRouteOption: '',
      selectedUrgencyOption: ''
    };
    
    // Auto-select first options
    const frequencyType = this.getFrequencyDisplayType();
    if (frequencyType === 'radio') {
      const frequencyOptions = this.getFrequencyOptions();
      if (frequencyOptions && frequencyOptions.length > 0) {
        this.qualifierData.selectedFrequencyOption = frequencyOptions[0].id;
      }
    }
    
    const routeUrgencyType = this.getRouteUrgencyDisplayType();
    if (routeUrgencyType === 'route') {
      const routeOptions = this.getRouteOptions();
      if (routeOptions && routeOptions.length > 0) {
        this.qualifierData.selectedRouteOption = routeOptions[0].id;
      }
    } else if (routeUrgencyType === 'urgency') {
      const urgencyOptions = this.getUrgencyOptions();
      if (urgencyOptions && urgencyOptions.length > 0) {
        this.qualifierData.selectedUrgencyOption = urgencyOptions[0].id;
      }
    }
  }

  closeQualifierPopup(): void {
    this.showQualifierPopup = false;
    this.selectedOrder = null;
    this.qualifierData = {
      frequency: '',
      urgency: 'routine',
      selectedFrequencyOption: '',
      selectedRouteOption: '',
      selectedUrgencyOption: ''
    };
  }

  // Utility method for testing different scenarios
  // This can be called from browser console for testing
  testScenario(scenario: 'frequency-input' | 'frequency-radio' | 'route' | 'urgency'): void {
    if (!this.selectedOrder) return;
    
    const testOrder = { ...this.selectedOrder };
    
    switch (scenario) {
      case 'frequency-input':
        testOrder.frequencyVal = '[2]';
        testOrder.routeUrgencyId = '';
        testOrder.routeUrgencyVal = '';
        break;
      case 'frequency-radio':
        testOrder.frequencyVal = '[1, 3]';
        testOrder.routeUrgencyId = '';
        testOrder.routeUrgencyVal = '';
        break;
      case 'route':
        testOrder.frequencyVal = '';
        testOrder.routeUrgencyId = '1';
        testOrder.routeUrgencyVal = '[4, 7, 10]'; // IV, Oral, Subcutaneous
        break;
      case 'urgency':
        testOrder.frequencyVal = '';
        testOrder.routeUrgencyId = '2';
        testOrder.routeUrgencyVal = '[1, 2]'; // Routine, Stat
        break;
    }
    
    this.onOrderClick(testOrder);
  }

  // Method to close error popup
  closeErrorPopup(): void {
    this.showErrorPopup = false;
    this.errorMessage = '';
  }
  
  // Method to check if an order is selected for current category
  isOrderSelected(order: Order): boolean {
    const selectedOrder = this.selectedOrdersForCategories.get(this.currentCategoryIndex);
    return selectedOrder ? selectedOrder.id === order.id : false;
  }

  // Calculate timing for a single order based on current simulation time
  private calculateOrderTiming(order: Order): void {
    if (!order) return;

    // Parse current simulation time
    const [currentHours, currentMinutes] = this.currentCaseTime.split(':').map(Number);
    
    // Check if order has return time structure (when backend provides it)
    // For now, we'll use a default structure as a placeholder
    // This should be replaced with actual data from backend
    let orderReturnTimeStructure = {
      days: 0,    // Default 0 day
      hours: 0,   // Default 0 hours  
      minutes: 0  // Default 0 minutes
    };
    
    // If order already has a return time structure from backend, use it
    if (order.orderReturnTime && typeof order.orderReturnTime === 'string') {
      try {
        orderReturnTimeStructure = JSON.parse(order.orderReturnTime);
      } catch (e) {
        console.error('Error parsing orderReturnTime:', e);
      }
    } else if (order.orderReturnTime && typeof order.orderReturnTime === 'object') {
      orderReturnTimeStructure = order.orderReturnTime;
    }
    
    // Calculate orderDay = current day + orderReturnTime.days
    order.orderDay = this.currentCaseDay + orderReturnTimeStructure.days;
    
    // Calculate return time = current time + (hours and minutes)
    const totalMinutes = (currentHours * 60) + currentMinutes + 
                        (orderReturnTimeStructure.hours * 60) + 
                        orderReturnTimeStructure.minutes;
    
    let returnHours = Math.floor(totalMinutes / 60);
    let returnMinutes = totalMinutes % 60;
    
    // Handle day overflow (if time goes beyond 24 hours)
    if (returnHours >= 24) {
      const extraDays = Math.floor(returnHours / 24);
      order.orderDay += extraDays;
      returnHours = returnHours % 24;
    }
    
    // Format return time as "HHMM" string
    const formattedHours = returnHours.toString().padStart(2, '0');
    const formattedMinutes = returnMinutes.toString().padStart(2, '0');
    order.orderReturnTime = `${formattedHours}${formattedMinutes}`;
  }

  // New method to get current orders list (either normal category or prerequisite)
  getCurrentOrdersList(): Order[] {
    if (this.currentCategory) {
      return this.currentCategory.orderslist;
    }
    return [];
  }

  // New method to get current order name for display
  getCurrentOrderName(): string {
    if (this.isPrerequisiteMode && this.currentCategory) {
      return this.currentCategory.value; // This will show "Prerequisites for X" or "Main Order: X"
    } else if (this.currentCategory) {
      return `Order Name: "${this.currentCategory.value}"`;
    }
    return '';
  }

  // New method to check if we can proceed (either normal or prerequisite mode)
  canProceed(): boolean {
    if (this.isPrerequisiteMode) {
      // In prerequisite mode, we don't use the confirm button in the same way
      // The flow is handled through individual order selection and qualification
      return true;
    }
    return this.selectedOrdersForCategories.has(this.currentCategoryIndex);
  }

  // Consultation popup methods
  onConsultationConfirm(): void {
    if (this.pendingConsultationOrder && this.consultationReason.trim()) {
      // Add consultation reason to the order
      const orderWithConsultation = {
        ...this.pendingConsultationOrder,
        consultationReason: this.consultationReason.trim()
      };

      // Calculate timing and track the order
      this.calculateOrderTiming(orderWithConsultation);
      this.removedOrderIds.add(orderWithConsultation.id);

      // Determine if this is the main order or a prerequisite
      const isMainOrder = this.isPrerequisiteMode && this.prerequisiteStack ? 
        this.prerequisiteStack.mainOrder.id === orderWithConsultation.id : false;

      // Emit the order with consultation data
      this.confirmOrders.emit({
        order: orderWithConsultation,
        isPrerequisite: !isMainOrder
      });

      // Close consultation popup
      this.closeConsultationPopup();
      
      // Check if we're in prerequisite mode and have more orders to process
      if (this.isPrerequisiteMode && this.prerequisiteStack) {
        // Remove the processed consultation order from the stack
        this.prerequisiteStack.prerequisiteChain.shift();
        console.log('Removed consultation order from stack, remaining:', this.prerequisiteStack.prerequisiteChain.map(o => o.orderName));
        
        if (this.prerequisiteStack.prerequisiteChain.length > 0) {
          // Continue with prerequisite processing - get next order to qualify
          const nextOrderToQualify = this.prerequisiteStack.prerequisiteChain[0]; // Get next order but don't remove it yet
          console.log('Next order to qualify after consultation:', nextOrderToQualify?.orderName);
          
          if (nextOrderToQualify) {
            // Show qualifier for the next order
            this.selectedOrder = nextOrderToQualify;
            this.showQualifierPopup = true;
            this.resetQualifierData();
            return; // Don't close the orders popup yet
          }
        }
        
        // No more orders in stack - finish prerequisite mode
        console.log('All orders qualified after consultation, finishing prerequisite mode');
        this.updateAvailableOrders();
        this.resetState();
        this.close.emit();
      } else {
        // If not in prerequisite mode, close the entire popup
        this.updateAvailableOrders();
        this.resetState();
        this.close.emit();
      }
    } else {
      // Show error if no consultation reason provided
      this.showErrorPopup = true;
      this.errorMessage = 'Please enter a reason for consultation before proceeding.';
    }
  }

  closeConsultationPopup(): void {
    this.showConsultationPopup = false;
    this.consultationReason = '';
    this.pendingConsultationOrder = null;
  }
} 